(function () {
    'use strict';
    angular.module('LoginModule', ['ui.router', 'ngStorage', 'toastr'])
        .service("config", function ($window, $location) {
            this.API_USER_MANAGEMENT = window.API_USER_MANAGEMENT;
        })
        .config(routeConfig)
        .config(toastrLibConfig)
        .factory('LoginSvc', function ($http, config) {
            return {
                login: function (data) {
                    var url = config.API_USER_MANAGEMENT + 'login';
                    return $http.post(url, data)
                },
                reset: function (data) {
                    var url = config.API_USER_MANAGEMENT + "reset-password";
                    return $http.post(url, data);
                },
            };
        })
        .controller('LoginCtrl', xxx);
        function routeConfig(
            $httpProvider,
            $localStorageProvider
        ) {
            $httpProvider.interceptors.push(function ($q,toastr) {
                return {
                    'responseError': function (res) {
                        if (res.data && res.data.ErrorCode) {
                            if (res.data.ErrorCode == 1) {
                                for (var i = 0; i < res.data.ValidationErrors.length; i++) {
                                    toastr.error(res.data.ValidationErrors[i].ErrorMessage);
                                }
                            } else {
                                toastr.error(res.data.Message);
                            }
                        }else if(res.status == -1){
                            toastr.error("Koneksi Internet Terputus");
                        } else {
                            toastr.error(res.statusText);
                        }
                        return $q.reject(res);
                    }
                };
            });
        }
    /** @ngInject */
    function toastrLibConfig(toastrConfig) {
        angular.extend(toastrConfig, {
            // closeButton: true,
            // closeHtml: '<button>&times;</button>',
            // // timeOut: 9000000000,
            // autoDismiss: false,
            // containerId: 'toast-container',
            // maxOpened: 0,
            // newestOnTop: true,
            // positionClass: 'toast-top-center',
            // preventDuplicates: false,
            // preventOpenDuplicates: false,
            // target: 'body'
            "autoDismiss": false,
            "positionClass": "toast-top-center",
            "timeOut": "1000",
            "allowHtml": false,
            "closeButton": true,
            "tapToDismiss": false,
            "newestOnTop": true,
            "maxOpened": 0,
            "preventDuplicates": false,
            "preventOpenDuplicates": false
        });
    }
    /** @ngInject */
    function xxx($timeout, $scope, $location, $localStorage, $state, config, $window, $http, toastr, LoginSvc) {
        $scope.form = {}
        $scope.$storage = $localStorage;
        // Helpdesk lives on its own subdomain (not a path under this portal's
        // own domain like the other modules), so it needs an absolute URL —
        // set per-environment in config.development.js / config.production.js,
        // same as window.URL / window.API_USER_MANAGEMENT.
        $scope.helpdeskUrl = window.HELPDESK_URL;
        $scope.sessionStatus = $window.location.href.split("&sessionexpired=")
        $scope.originURL = $scope.sessionStatus[0].split("origin_url=")
        if ($scope.originURL[1] !== undefined) {
            $scope.OriginUrlAppId = $scope.originURL[1].split("&app_id=")
        } else {
            $scope.OriginUrlAppId = [undefined, undefined]
        }
        $scope.showPassword = false;
        $scope.showPasswordOrNot = function(){
            $scope.showPassword = !$scope.showPassword
        }
        $scope.messageSent == false
        $scope.isOriginEmpty = false
        $scope.displayBlock = {
            'display': 'none'
        }
        $scope.displayUsername = {
            'display': 'none'
        }
        $scope.dontBlockNormal = {
            'display': 'none'
        }
        $scope.dontBlockSent = {
            'display': 'none'
        }
        if (!$scope.messageSent) {
            $scope.dontBlockNormal = {
                'display': 'block'
            }
            $scope.dontBlockSent = {
                'display': 'none'
            }
        } else {
            $scope.dontBlockNormal = {
                'display': 'none'
            }
            $scope.dontBlockSent = {
                'display': 'block'
            }
        }
        if ($scope.originURL[1] == undefined || $scope.OriginUrlAppId[1] == undefined) {
            $scope.displayBlock = {
                'display': 'block'
            }

        } else {
            $scope.displayUsername = {
                'display': 'block'
            }
        }

        if ($scope.sessionStatus[1] == 'true') {
            $localStorage.$reset();
        } else {

            if ($scope.OriginUrlAppId[0] !== undefined && $localStorage.AuthKey != undefined) {
                $window.location.href = $scope.OriginUrlAppId[0] + '?AuthKey=' + $localStorage.AuthKey
            }
        }
        $scope.login = function () {
            $scope.isLoading = true;
            $scope.form.ApplicationId = $scope.OriginUrlAppId[1]
            LoginSvc.login($scope.form).then(function (res) {
                if (res.data.ErrorCode !== 0) {
                    $scope.isLoading = false;
                    toastr.error(res.data.Message);
                } else {
                    $localStorage.isLogin = true;
                    $localStorage.AuthKey = res.headers("AuthKey")
                    toastr.success(res.data.Message);
                    $window.location.href = $scope.OriginUrlAppId[0] + '?AuthKey=' + res.headers("AuthKey");
                    $scope.isLoading = false;
                }
            }).catch(function(e){
                $scope.isLoading = false;
            })
        }
        $scope.ResetPassword = function () {
            $scope.isLoading = true;
            LoginSvc.reset($scope.form.email).then(function (res) {
                if (res.data.ErrorCode !== 0) {
                    $scope.isLoading = false;
                    toastr.error(res.data.Message.split('|')[0]);
                } else {
                    toastr.success(res.data.Message);
                    $scope.isLoading = false;
                    $scope.messageSent = true

                    $scope.dontBlockNormal = {
                        'display': 'none'
                    }
                    $scope.dontBlockSent = {
                        'display': 'block'
                    }
                }
            }).catch(function(e){
                $scope.isLoading = false;
            })
        }
        var servers = window.location.href;
        $scope.setOrigin = function (origin) {
            $scope.displayUsername = {
                'display': 'none'
            }
            $scope.displayUsername = {
                'display': 'none'
            }
            $window.location.href = servers + '?origin_url=' + origin
        }
    }
})();
